/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Missing_Items_InvalidInputs */

const en_error_missing_items_invalid = /** @type {(inputs: Error_Missing_Items_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This choice cannot be accepted for the missing units. Choose one of those offered, and add a file only with a credit note.`)
};

/**
* | output |
* | --- |
* | "This choice cannot be accepted for the missing units. Choose one of those offered, and add a file only with a credit note." |
*
* @param {Error_Missing_Items_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_missing_items_invalid = /** @type {((inputs?: Error_Missing_Items_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Missing_Items_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_missing_items_invalid(inputs)
});